import { employeesApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { TaxJurisdictionGateway } from './TaxJurisdictionGateway';
import type { JurisdictionCatalog } from './types';
import { mapJurisdictionCatalog } from './wire';

export class HttpTaxJurisdictionGateway implements TaxJurisdictionGateway {
  private readonly request = createJsonClient(employeesApiBaseUrl);

  async getCatalog(): Promise<JurisdictionCatalog> {
    return mapJurisdictionCatalog(await this.request<unknown>('/api/tax-jurisdictions'));
  }
}
